import './style.scss';

document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.booom-texttabgridcards').forEach(function (section) {
        section.querySelectorAll('.ttgc-tab-btn').forEach(function (btn) {
            btn.addEventListener('click', function () {
                const panelId   = btn.dataset.panel;
                const allBtns   = section.querySelectorAll('.ttgc-tab-btn');
                const allPanels = section.querySelectorAll('.ttgc-panel');

                allBtns.forEach(function (b) {
                    b.classList.remove('is-active');
                    b.setAttribute('aria-selected', 'false');
                });

                btn.classList.add('is-active');
                btn.setAttribute('aria-selected', 'true');

                allPanels.forEach(function (p) { p.classList.remove('is-visible'); });

                const panel = document.getElementById(panelId);
                if (panel) panel.classList.add('is-visible');
            });
        });
    });
});
